import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "45.349",
  viewBox: "0 0 45.349 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fill: "#81c564",
    d: "M22.658.01S33.72-.397 41.096 3.7c0 0 2.254 1.228 3.073 3.482 0 0 8.81 29.706-21.718 42.818 0 0-27.863-9.834-21.51-42 0 0 .41-3.277 4.506-4.916C5.243 2.88 11.39.012 22.658.012z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#412f1f",
    d: "M4.834 7.592S9.136 3.7 22.248 3.7c0 0 12.087-.206 17.414 3.892 0 0 9.424 23.56-17.21 38.106.206.205-24.993-10.654-17.618-38.106z"
  }), /*#__PURE__*/_jsx("path", {
    fill: " #81c564",
    d: "M29.214 20.908c-1.64-7.17-5.532-9.63-5.942-10.448-.41-.615-.82-1.844-.82-1.844V8.41c0 .616 0 .82-.614 1.435-1.024.82-5.736 4.712-6.146 12.907-.41 7.58 5.532 12.087 6.35 12.702.616 1.23.616 3.688.616 3.688l.82.205s-.205-2.254 0-3.278c0-.41.204-.617.41-.82.204 0 .41-.41 1.024-.82 1.64-1.64 5.53-6.147 4.302-13.523z"
  })]
});